import sejamClient from "$clients/sejam/sejam.client.js";
import sepahBrokerClients from "$clients/sepah/sepah-broker.client.js";
import smsClient from "$clients/sms/sms.client.js";
import tadbirClient from "$clients/tadbir/tadbir.client.js";

export { sejamClient, sepahBrokerClients, smsClient, tadbirClient };
